import { Key } from 'react';
import { AvatarGroup } from '@rossum/ui/material';
import UserAvatar, { User } from './UserAvatar';

type MaybeUser = (User & { id: Key }) | undefined;

type UserAvatarGroupProps = {
  users: Array<MaybeUser>;
};

const UserAvatarGroup = ({ users }: UserAvatarGroupProps) => (
  <AvatarGroup sx={{ justifyContent: 'start' }} total={users.length}>
    {users
      .map((user, index) => (
        // oxlint-disable-next-line react/no-array-index-key -- oxlint stricter than eslint — index used as fallback, not sole key
        <UserAvatar key={user ? user.id : `u${index}`} user={user} />
      ))
      .slice(0, 3)}
  </AvatarGroup>
);

export default UserAvatarGroup;
